import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitLines'
})
export class SplitLinesPipe implements PipeTransform {

  transform(value: string): string[] {
    return value ? value.split('\n') : [];
  }

}
